import { useContext } from 'react';
import { RealtimeContext } from './realtime-provider';
import type { RealtimeContextValue } from './types';

export const useRealtimeContext = (): RealtimeContextValue => {
  const context = useContext(RealtimeContext);
  if (!context) {
    throw new Error('useRealtimeContext must be used inside RealtimeProvider.');
  }

  return context;
};
